import React, {PureComponent} from "react"
import {get} from "lodash"

import BrandAvatar from "@irati/ui/src/BrandAvatar"
import {Perks} from "@irati/admin/types"
import Flex from "@irati/ui/src/Flex"
import {Label, H6} from "@irati/ui/src/Typography"

import {ImageWrapper} from "./styled"

interface Props {
  row: Perks
  headerAccessor: string
  logoUrl: string
  brandName: string
}

class PopularPerks extends PureComponent<Props> {
  render() {
    const {row, headerAccessor, logoUrl, brandName} = this.props
    const perksName = get(row, headerAccessor)
    const logo = get(row, logoUrl)
    const brand = get(row, brandName)

    return (
      <Flex alignItems="center" paddingLeft={1.5}>
        <ImageWrapper>
          <BrandAvatar src={logo} extraSmall />
        </ImageWrapper>
        <Flex direction="column">
          <Label>{brand}</Label>
          <H6>{perksName}</H6>
        </Flex>
      </Flex>
    )
  }
}

export default PopularPerks
